import React, { useId } from 'react'

import { Button, Icon, InfoOutlined, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, node, number, string } from 'prop-types'

import formatPrice from 'Utils/formatPrice'
import { NOOP } from 'Utils/stableDefaults'

function OrderSummary({
  title,
  children,
  subtotal,
  subtotalLabel,
  vatAmount = 0,
  vatLabel = '',
  vatTooltip = '',
  total,
  totalLabel,
  payLabel = '',
  onPay: handlePay = NOOP,
  disabled = true,
  hidePay = false,
  legal = null,
  footer = null,
}) {
  const id = useId()

  return (
    <div className="order-summary">
      <h2 className="order-summary__title cgt-heading-300">{title}</h2>

      {children}

      <hr className="order-summary__divider" />

      <div className="order-summary__totals">
        <div className="order-summary__row">
          <span className="cgt-body-base-semibold">{subtotalLabel}</span>
          <span className="cgt-body-base">{formatPrice(subtotal)}</span>
        </div>
        {vatAmount > 0 && (
          <div className="order-summary__row">
            <span className="order-summary__row-label--with-info cgt-body-base">
              {vatLabel}
              {vatTooltip && (
                <Tooltip content={vatTooltip} id={id}>
                  <span className="order-summary__info-icon">
                    <Icon size="small" svgComponent={InfoOutlined} color="dark" />
                  </span>
                </Tooltip>
              )}
            </span>
            <span className="cgt-body-base">{formatPrice(vatAmount)}</span>
          </div>
        )}
      </div>

      <hr className="order-summary__divider" />

      <div className="order-summary__total-row">
        <span className="cgt-heading-50">{totalLabel}</span>
        <span className="order-summary__total-amount cgt-heading-200">{formatPrice(total)}</span>
      </div>

      {!hidePay && (
        <Button
          type="primary"
          expand
          customClass="order-summary__pay-button"
          onClick={handlePay}
          disabled={disabled}
        >
          {payLabel}
        </Button>
      )}

      {legal && <div className="order-summary__legal cgt-body-base">{legal}</div>}
      {footer && <div className="order-summary__footer">{footer}</div>}
    </div>
  )
}

OrderSummary.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
  subtotal: number.isRequired,
  subtotalLabel: string.isRequired,
  vatAmount: number,
  vatLabel: string,
  vatTooltip: string,
  total: number.isRequired,
  totalLabel: string.isRequired,
  payLabel: string,
  onPay: func,
  disabled: bool,
  hidePay: bool,
  legal: node,
  footer: node,
}

export default OrderSummary
